import { useRef, useEffect } from 'react';

const pillars = [
  {
    icon: 'ri-leaf-fill',
    title: '100% Organic',
    description: 'Every ingredient is sourced from pure, natural origins — no synthetic fertilisers, no pesticides, no compromises.',
    color: 'bg-brand-olive/10',
    iconColor: 'text-brand-olive',
  },
  {
    icon: 'ri-hand-heart-fill',
    title: 'Hand Crafted',
    description: 'Each product is made by skilled hands using time-honoured techniques passed down through generations.',
    color: 'bg-brand-gold/10',
    iconColor: 'text-brand-gold',
  },
  {
    icon: 'ri-tools-fill',
    title: 'No Machine Processing',
    description: 'We reject industrial shortcuts. Everything is crushed, ground and blended entirely by hand — preserving nutrients and integrity.',
    color: 'bg-brand-beige',
    iconColor: 'text-brand-brown',
  },
  {
    icon: 'ri-heart-3-fill',
    title: 'Pure & Chemical-Free',
    description: 'Absolutely zero additives, preservatives or artificial colouring. Just nature, as it was intended to be.',
    color: 'bg-brand-brown/10',
    iconColor: 'text-brand-brown-dark',
  },
];

const CoreValues = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.scroll-animate').forEach((child) => {
              child.classList.add('visible');
            });
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-brand-cream px-4 md:px-8" ref={ref}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 scroll-animate">
          <span className="inline-block font-sans text-xs tracking-[0.25em] uppercase text-brand-olive font-medium mb-3">
            Our Promise
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-brand-brown-dark font-bold mb-4">
            Our Promise to You
          </h2>
          <div className="w-16 h-0.5 bg-brand-gold mx-auto"></div>
        </div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar, index) => (
            <div
              key={pillar.title}
              className={`scroll-animate scroll-animate-delay-${index + 1} ${pillar.color} rounded-2xl p-8 text-center hover:-translate-y-1 transition-transform duration-300 cursor-default`}
            >
              <div className={`w-14 h-14 flex items-center justify-center mx-auto mb-5 rounded-full bg-white/70`}>
                <i className={`${pillar.icon} text-2xl ${pillar.iconColor}`}></i>
              </div>
              <h3 className="font-serif text-xl text-brand-brown-dark font-semibold mb-3">
                {pillar.title}
              </h3>
              <p className="font-sans text-sm text-brand-brown/80 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
